module.exports = __webpack_public_path__ + "22d50712647dc6bf06f8f6a637f9f91c.svg";